import FormStore from '../../../utils/stores/FormStore'
import { action, makeObservable, observable } from 'mobx'
import moment from 'moment'
import { getComp } from '../../../utils/utils/DI'

export const initParamsState = {
  id: '',
  phoneNumber: '',
  dateOfMaintenanceFrom: null,
  dateOfMaintenanceTo: null,
  fullName: '',
  address: '',
  status: '',
  statuses: [],
  dataCheckingStatuses: [],
  ticketStatuses: [],
  fullAddress: '',
}

const validateData = {
  status: { required: true },
}

class ServiceReportsFilterStore extends FormStore {
  dealersStore: any
  data: any = initParamsState
  param: any
  constructor() {
    super({
      initState: initParamsState,
      validateData,
    })
    this.dateNames = [['dateOfMaintenanceFrom', 'dateOfMaintenanceTo']]
    this.dealersStore = getComp('DealersStore')
    makeObservable(this, {
      isHighlighted: observable,
      data: observable,
      makeHighlightTrue: action,
      makeHighlightFalse: action,
    })
  }

  isHighlighted = false

  makeHighlightTrue = () => {
    if (this.data?.id !== '') {
      return
    }
    this.isHighlighted = true
  }

  makeHighlightFalse = () => (this.isHighlighted = false)

  clear = () => {
    this.setData(initParamsState)
    this.makeHighlightFalse()
    this.param = null
    this.clearSelectedFilters()
  }

  makeParamCopy = (param: any) => {
    this.param = param
  }

  getParamCopy = () => this.param

  getParams = () => {
    const param = {} as Record<string, any>

    for (const key in this.data) {
      if (!!this.data[key]) {
        switch (key) {
          case 'dateOfMaintenanceFrom':
          case 'dateOfMaintenanceTo':
            if (key.includes('From')) {
              param[key] = this.data[key].format()
            } else {
              param[key] = this.data[key].endOf('day').format()
            }
            break
          case 'year':
            param['year'] = this.data[key]
            break
          case 'month':
            param['month'] = this.data[key]
            param['year']
              ? (param['year'] = param['year'])
              : (param['year'] = +moment().year())
            break
          case 'phoneNumber':
            param['phoneNumber'] = normalizePhoneNumber(this.data[key])
            break
          default:
            param[key] = this.data[key]
            break
        }
      }
    }
    return param
  }
}

function normalizePhoneNumber(phoneNumber: string | number) {
  return String(phoneNumber).replace(/\D/g, '')
}

const singleReportsFilterStore = new ServiceReportsFilterStore()

export default singleReportsFilterStore
